// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"117":"ed34c16d","122":"27600fcd","189":"96b2d458","192":"1de4e629","443":"2f226199","498":"2ba26509","562":"5de7d378","591":"3e937e44","599":"0038cdb3","642":"ebba2e91","669":"08e7a8ec","819":"46e9c2bb"}[chunkId] + ".js";
};